const base = {
    // egg: 'https://site.hqaiot.com',测试
    egg: 'https://www.hqaiot.com/',
}

export default base